import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import toastr from "../../../utils/toast";

function EditUser({ id, onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  
  const {
      register,
      handleSubmit,
      watch,
      setValue,
      unregister,
      formState: { errors },
    } = useForm();
  const [ref, setref] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [modules, setModules] = useState([]);
  const [checkedModules, setCheckedModules] = useState([]);
  
 const fetchOptions = async() => {
   //   setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/settings/get_user_details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            },
          }
        );
        if(response.data.searchUser.length > 0){
          setref(response.data.searchUser?.[0]);
        }
        
      } catch (error) {
        console.error("API Error:", error);
        setGlobalLoading(false);
      }
    }

  useEffect(() => {
   fetchOptions();
  }, [id, designation]);

  useEffect(()=>{
    setValue("id",ref.id);
    setValue("firstname",ref?.firstname);
    setValue("lastname",ref?.lastname);
    setValue("username",ref?.username);
    setValue("email",ref?.email);
    setValue("phone",ref?.phone);
    setValue("workphone",ref.workphone);
    setValue("designation_id",ref?.designation_id);
    setValue("status",ref?.status);
    setValue("admin",ref?.admin);
    setValue("unlock",ref?.unlock);
    setValue("parmanent",ref?.parmanent);

    if (ref.module_access) {
          const storedModules = ref?.module_access
            .split(",")
            .map((id) => parseInt(id.trim()));
          setCheckedModules(storedModules);
        }
  },[ref]);

  useEffect(() => {
    async function fetchAllDropdownData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/settings/get_designation_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data;
        setDesignation(data.designation || []);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchAllDropdownData();
  }, []);

  useEffect(() => {
    async function fetchModulesData() {
      setGlobalLoading(false); //  Show loader before API call
      try {
        const res = await axios.get(`${API_BASE_URL}/settings/get_modules_list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data.modules || [];
        const moduleMap = {};
        
        data.forEach((m) => (moduleMap[m.id] = { ...m, children: [] }));
        const tree = [];
        data.forEach((m) => {
          if (m.parent === "0") tree.push(moduleMap[m.id]);
          else if (moduleMap[m.parent]) moduleMap[m.parent].children.push(moduleMap[m.id]);
        });

        setModules(tree);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    }
    fetchModulesData();
  }, []);

  // Toggle checkbox
  const handleCheck = (id, isParent, children = []) => {
    setCheckedModules((prev) => {
      let updated = [...prev];

      if (updated.includes(id)) {
        // Uncheck parent + all children
        updated = updated.filter(
          (item) => item !== id && !children.map((c) => c.id).includes(item)
        );
      } else {
        // Check parent + all children
        updated.push(id);
        if (isParent && children.length) {
          updated.push(...children.map((c) => c.id));
        }
      }

      return [...new Set(updated)]; // remove duplicates
    });
  };

  // Handle child check
  const handleChildCheck = (parentId, childId, siblings) => {
    setCheckedModules((prev) => {
      let updated = [...prev];

      // toggle the child
      if (updated.includes(childId)) {
        updated = updated.filter((id) => id !== childId);
      } else {
        updated.push(childId);
      }

      // ✅ if at least one child is checked → parent checked
      const anyChildChecked = siblings.some((c) => updated.includes(c.id));

      if (anyChildChecked) {
        if (!updated.includes(parentId)) updated.push(parentId);
      } else {
        updated = updated.filter((id) => id !== parentId);
      }

      return [...new Set(updated)];
    });
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    // loop through all keys in data
    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (value instanceof FileList) {
        // if it's a file input (FileList), add first file
        
        if (value.length > 0) {
          formData.append(key, value[0]);
        }
      } else {
        // otherwise add as a normal field
        formData.append(key, value);
      }
    });
    checkedModules.forEach((modId) => {
      formData.append("module_access[]", modId);
    });
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/settings/edit_user`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    //  console.log(response);
      toastr.success("User update successfully!");
      onClose();
      setTimeout(() => {
        navigate("/settings/users");
      }, 1000);

      // setShowModal(false);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 

   return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "650px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Edit User</h4>
              <button
                onClick={() => onClose()}
                type="button" className="btn-close custom-btn-close"
                data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">First Name *</label>
                    <input type="hidden" {...register("id")} />
                    <input type="text" {...register("firstname", { required: "required" })} className={`form-control ${ errors.firstname && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Username *</label>
                    <input type="text" {...register("username", { required: "required" })} className={`form-control ${ errors.username && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Personal Phone </label>
                    <input type="text" {...register("phone")} className={`form-control ${ errors.phone && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Password </label>
                    <input type="password" {...register("password")} className={`form-control ${ errors.password && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Designation *</label>
                    <select {...register("designation_id", {required: "Please select Designation",})} className={`form-select ${ errors.designation_id && "is-invalid" }`}>
                      <option value="">Select</option>
                      {designation.map((m) => (
                        <option key={m.id} value={m.id}>{m.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Status</label>
                      <select {...register("status")} className="form-select">
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Unlock</label>
                      <select {...register("unlock")} className="form-select">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="mb-2">
                    <label className="form-label">Last Name *</label>
                    <input type="text" {...register("lastname", { required: "required" })} className={`form-control ${ errors.lastname && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Email *</label>
                    <input type="text" {...register("email", { required: "required" })} className={`form-control ${ errors.email && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Work Phone *</label>
                    <input type="text" {...register("workphone")} className={`form-control ${ errors.workphone && "is-invalid"}`} minlength="6" />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Confirm Password </label>
                    <input type="password" 
                    {...register("confirm_password", { validate: (value) =>  value === watch("password") || "Passwords do not match",})} 
                    className={`form-control ${ errors.confirm_password && "is-invalid"}`} />
                  </div>
                  <div className="mb-2">
                      <label className="form-label">Profile Picture (max 180x180)</label>
                      <input type="file" className="form-control" {...register("file_name")} />
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Admin</label>
                      <select {...register("admin")} className="form-select">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Parmanent</label>
                      <select {...register("parmanent")} className="form-select">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 mb-3">
                  <label className="form-label">Module Permissions</label>
                    <ul className="accesslist" style={{ listStyle: "none", padding: 0 }}>
                      {modules.map((mod) => (
                        <li key={mod.id} style={{ marginBottom: "5px" }}>
                          <label>
                            <input name="module_access" type="checkbox" className="cb" value={mod.id} checked={checkedModules.includes(mod.id)} onChange={() => handleCheck(mod.id, true, mod.children)}/>
                              {" "}<strong>{mod.name}</strong>
                          </label>

                          {/* Render children */}
                          {mod.children.length > 0 && (
                            <ul style={{ marginLeft: "20px", listStyle: "none", padding: 0 }}>
                              {mod.children.map((child) => (
                                <li key={child.id}>
                                  <label>
                                    <input name="module_access" type="checkbox" className="cb" value={child.id} checked={checkedModules.includes(child.id)} onChange={() => handleChildCheck(mod.id, child.id, mod.children)}/>
                                    {" "}{child.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   );  

}    
export default EditUser;